export type UserRole = 'Admin' | 'SalesRepresentative';

export const adminRoles: UserRole[] = ['Admin'];

export const allLoggedInRoles: UserRole[] = ['SalesRepresentative', 'Admin'];

export const isVisibleForRoles = (
  requiredRoles: string | readonly string[] | undefined,
  userRoles: readonly string[],
): boolean => {
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  const allowedRoles = typeof requiredRoles === 'string' ? [requiredRoles] : requiredRoles;
  return allowedRoles.some((role) => userRoles.includes(role));
};
